import React from "react";
import {
  Box,
  Typography,
  Paper,
  Avatar,
  Divider,
  Button,
  Stack,
} from "@mui/material";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";

const PerfilPage = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  if (!user) {
    return (
      <>
        <Navbar />
        <Box sx={{ mt: 12, textAlign: "center" }}>
          <Typography variant="h6">
            Debes iniciar sesión para ver tu perfil
          </Typography>
        </Box>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Navbar />

      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box sx={{ flexGrow: 1, mt: 10, mb: 10 }}>
          <Box sx={{ maxWidth: 500, mx: "auto", px: 2 }}>
            <Paper sx={{ p: 4, textAlign: "center" }}>
              {/* Avatar */}
           
  <Avatar
      src={user.avatar || undefined}
      sx={{
          width: 100,
                  height: 100,
                  mx: "auto",
                  mb: 2,

        bgcolor: user.avatar
          ? "transparent"
          : user.background_avatar || "#1976d2",
        color: "#fff",
      }}
    >
      {!user.avatar && user.name
        ? user.name.charAt(0).toUpperCase()
        : null}
    </Avatar>
              <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                Mi Perfil
              </Typography>

              <Divider sx={{ my: 3 }} />

              {/* Datos */}
              <Stack spacing={2}>
                 <Box>
                  <Typography variant="subtitle2" color="text.secondary">
                    Nombre
                  </Typography>
                  <Typography>{user.name} {user.lastName}</Typography>
                </Box>
                <Box>
                  <Typography variant="subtitle2" color="text.secondary">
                    Email
                  </Typography>
                  <Typography>{user.email}</Typography>
                </Box>

               
              </Stack>

              <Divider sx={{ my: 3 }} />

              {/* Acciones */}
              <Stack spacing={2}>
               
<Button
  variant="outlined"
  onClick={() => navigate("/actualizar-perfil")}
>
  Editar perfil
</Button>
        
              </Stack>
            </Paper>
          </Box>
        </Box>

        <Footer />
      </Box>
    </>
  );
};

export default PerfilPage;
